import React from "react";

import { ErrorBoundary } from "react-error-boundary";


export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
          <h2 className="font-semibold mb-2">Something went wrong.</h2>
          <p className="text-sm">{error.message}</p>
          <button
            onClick={resetErrorBoundary}
            className="mt-3 bg-red-600 text-white px-3 py-2 rounded-md"
          >
            Try again
          </button>
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}